import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import PasswordReset from '@/features/Auth/PasswordReset'
import { validateTokenHandler } from '@/features/Auth/PasswordReset/server.ts'
import { RouteErrorComponent } from '@/shared/RouteErrorComponent/RouteErrorComponent.tsx'

const passwordResetSearchSchema = z.object({
    token: z.string().optional(),
})

export const Route = createFileRoute('/_public/password-reset')({
    component: RouteComponent,
    onError: RouteErrorComponent,
    validateSearch: function (search: Record<string, unknown>) {
        const result = passwordResetSearchSchema.safeParse(search)

        return {
            token: result.success ? (result.data.token ?? '') : '',
        }
    },
    beforeLoad: async function (context) {
        const { token } = context.search

        if (!token) {
            throw redirect({
                to: '/login',
                hash: 'password-reset-token-missing',
            })
        }

        const tokenIsValid = await validateTokenHandler({
            data: { token },
        })

        if (tokenIsValid.length === 0) {
            throw redirect({
                to: '/login',
                hash: 'password-reset-token-invalid',
            })
        }
    },
})

function RouteComponent() {
    const { token } = Route.useSearch()

    return <PasswordReset token={token} />
}
